<template>
  <div class="main">
    <div class="wamp">
      <h2>门店系统</h2>
      <div class="header">
        <left></left>
        <content-v class="content"></content-v>
        <right></right>
      </div>
      <div class="footer">
        <fleft></fleft>
        <fright></fright>
      </div>
    </div>
  </div>
</template>

<script>
import Left from "@/components/left/Left";
import ContentV from "@/components/content/ContentV";
import Right from "@/components/right/Right";
import Fleft from "@/components/footer/Fleft";
import Fright from "./footer/Fright.vue";
export default {
  name: "MainCenter",
  components: {
    Left,
    ContentV,
    Right,
    Fleft,
    Fright,
  },
};
</script>

<style lang="less">
.main {
  width: 100%;
  height: 97%;
  position: relative;
  &::before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 999;
    top: -5rem;
    background: url("../assets/image/背景1.png") no-repeat;
    background-size: 100% 100%;
  }
  &::after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 2rem;
    z-index: 0;
    background: url("../assets/image/背景2.png") no-repeat;
    background-size: 100% 100%;
  }
  .wamp {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    color: white;
    & > h2 {
      height: 2.5rem;
      line-height: 2.5rem;
      text-align: center;
      font-size: 2rem;
      color: white;
      position: relative;
      z-index: 999;
    }
    .header {
      width: 100%;
      height: 50%;
      display: flex;
      justify-content: space-around;
      & > div {
        flex: 3;
      }
      .content {
        flex: 4;
      }
    }
    .footer {
      width: 100%;
      height: 65%;
      position: relative;
      z-index: 999;
      display: flex;
      justify-content: space-between;
      & > div {
        width: 40%;
      }
      & > div:last-child{
        width: 59%;
      }
    }
  }
}
</style>